import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";

export default function CookiePolicy() {
  return (
    <div data-testid="cookie-policy-page">
      <SEO title="Cookie Policy" description="Cookie Policy for WomensMatchDayLive." path="/cookie-policy" />
      <PageHero eyebrow="Legal" title="Cookie Policy" crumbLabel="Cookie Policy" />
      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-6 lg:px-12">
          {["What Are Cookies", "Cookies We Use", "Analytics & Marketing Cookies", "Managing Cookies"].map((heading) => (
            <div key={heading}>
              <h2 className="font-heading text-2xl uppercase text-brand-black">{heading}</h2>
              <p className="mt-2 text-black/60">Text goes here</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
